import React from 'react';
import PageTitle from '../layouts/PageTitle';
import NominationCSVExport from './NominationCSVExport';

const SecretaryActions = () => (
  <>
    <PageTitle activeMenu="Secretary Actions" motherMenu="Home" />
    <NominationCSVExport />
  </>
);

export default SecretaryActions;
